// extracted by mini-css-extract-plugin
module.exports = {"skipLink":"navbar_skipLink__2PX2C","notifystyle":"navbar_notifystyle__2usSi","navbarnav":"navbar_navbarnav__2uYrW"};